<template>
    <div></div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex';
    import OT from "@opentok/client";
    import api from "../../../../../admin/api/api";

    export default {
        name: 'subscriber',
        props: {
            opts: {
                type: Object,
                required: false
            }
        },
        computed: {
            ...mapState('conference', [
                'session',
                'mediaAccess',
                'streams',
                'subscriber'
            ]),
            ...mapState([
                'user',
            ]),
        },
        mounted: function() {
            let subscriber = this.session.subscribe(this.streams[0], this.$el, this.opts);

            this.setSubscriber(subscriber);

             this.subscriber.on('videoElementCreated', () => {
                 this.session.signal({
                         type: "subscriberElementCreated",
                         data: {
                             userId: this.user.id,
                             mediaAccess: this.mediaAccess
                         }
                     }
                 );
             });
        },
        methods: {
            ...mapMutations('conference', [
                'setSubscriber'
            ])
        }
    };
</script>
